import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.scss";
import "../styles/custom.css";
import Pagination from "./pagination";
import { withTranslation } from "react-i18next";
import numberFormatter from "../util/numberFormat.js";
import i18n from "i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getProducts,
  paginate,
  clearAllOptions,
  getFilter,
  setOptions,
} from "../store/reducers/filterSlice";
import Loader from "./loader";

class Products extends React.Component {
  constructor(props) {
    super(props);

    this.getUnits = (product) => {
      const units = product.units.filter((el) => {
        return (
          el.class == this.props.class &&
          this.props.frequency.includes(el.frequency)
        );
      });

      return units;
    };

    // this.getDefaultUrlState = (product) => {
    //   if(product.units.length) {
    //     const searchParams = new URLSearchParams({frequency: product.units[0].frequency_code, class: product.units[0].class});
    //     return "?" + searchParams.toString()
    //   }

    //   return "";
    // }

    this.getDefaultUrlState = (product) => {
      if (product.units.length) {
        return (
          "/" +
          product.units[0].class +
          "/" +
          product.units[0].frequency_code.replace("frequenz", "")
        );
      }

      return "";
    };

    this.getRanges = (rangeItems) => {
      const units = Object.values(this.props.range).map((el) => el.unit);

      const items = Object.values(rangeItems).filter((el) => {
        return (
          Object.keys(this.props.range).includes(el.name) &&
          units.includes(el.unit)
        );
      });
      return items;
    };

    this.paginate = (page) => {
      this.props.paginate(page);

      const listContainer = document.querySelector(".list-container");
      if (listContainer) {
        window.scrollTo({
          top: listContainer.offsetTop,
          behavior: "smooth",
        });
      }
    };
    this.paginateNext = () => {
      this.props.paginate(parseInt(this.props.pagination.page) + 1);
    };
    this.paginatePrev = () => {
      this.props.paginate(parseInt(this.props.pagination.page) - 1);
    };
  }
  render() {
    const { t } = this.props;

    if (this.props.loading) {
      return <Loader />;
    }

    return (
      <>
        {/* <h1>{t("Search result")}</h1> */}
        <div id="products-container">
          {/* <div className="list-filter-container">
            <p>{t("Your selection:")}</p>
            {Object.entries(this.props.selectedOptions).map((opt, i) => {
              const option = opt[0];

              return opt[1].map((value) => (
                <button key={i} className="filter-button">
                  {value}
                  <span
                    className="remove-icon"
                    onClick={() => {
                      this.props.setOptions({ option: option, value: value });
                    }}
                  ></span>
                </button>
              ));
            })}
          </div> */}

          {/* <p>{this.props.productsCount} {t('Products selected')}</p> */}
          <div className="products-grid">
            {this.props.products.map((product, i) => (
              <div className="list-item-container" key={i}>
                <a
                  href={
                    window.location.origin +
                    window.location.pathname +
                    "/#/detail/" +
                    product.slug +
                    this.getDefaultUrlState(product)
                  }
                  className="list-item-image-container"
                >
                  <img
                    src={
                      import.meta.env.VITE_IMAGES_BASE +
                      product.gallery[0].image
                    }
                  />
                </a>
                <div className="list-item-description-container">
                  <h2>
                    <a
                      href={
                        window.location.origin +
                        window.location.pathname +
                        "/#/detail/" +
                        product.slug +
                        this.getDefaultUrlState(product)
                      }
                    >
                      {product.title}
                    </a>
                  </h2>
                  <h3>{product.product_type}</h3>
                  <div className="attr-container-wrap">
                    <div className="attr-containers">
                      <div className="attr-container">
                        {this.getUnits(product).map((unit, j) => (
                          <div key={j} className="attr-row">
                            <div className="col-1">
                              <h4>{unit.frequency}</h4>
                            </div>
                            <div className="col-2">
                              {this.getRanges(unit.items).map((item, i) => {
                                const html =
                                  item.title +
                                  " <span class='range-value'>" +
                                  numberFormatter.numberFormat(
                                    item.min,
                                    i18n.language
                                  ) +
                                  " - " +
                                  numberFormatter.numberFormat(
                                    item.max,
                                    i18n.language
                                  ) +
                                  " " +
                                  item.label +
                                  "</span>";
                                return (
                                  <p
                                    key={i}
                                    dangerouslySetInnerHTML={{ __html: html }}
                                  />
                                );
                              })}
                            </div>
                            <div className="link">
                              <a
                                href={
                                  window.location.origin +
                                  window.location.pathname +
                                  "/#/detail/" +
                                  product.slug +
                                  "/" +
                                  unit.class +
                                  "/" +
                                  unit.frequency_code.replace("frequenz", "")
                                }
                                className="show-details"
                              >
                                {t("Show details")}
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clear-both"></div>
              </div>
            ))}
          </div>
          {(() => {
            if (this.props.pagination) {
              return (
                <Pagination
                  pagination={this.props.pagination}
                  paginate={this.paginate}
                  paginatePrev={this.paginatePrev}
                  paginateNext={this.paginateNext}
                />
              );
            }
          })()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.filter.products,
    pagination: state.filter.pagination,
    productsCount: state.filter.productsCount,
    selectedOptions: state.filter.request.options,
    class: state.filter.request.class,
    range: state.filter.request.range,
    frequency: state.filter.request.frequency,
    loading: state.filter.productLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      paginate: (args) => (dispatch) => {
        dispatch(paginate(args));
        dispatch(getProducts());
      },
      clearAllOptions: () => (dispatch) => {
        dispatch(clearAllOptions());
        dispatch(getProducts());
      },
      removeOption: (args) => (dispatch) => {
        dispatch(removeOption(args));
        dispatch(getProducts());
      },
      setOptions: (args) => (dispatch) => {
        dispatch(setOptions(args));
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Products));
